// extracted by mini-css-extract-plugin
export default {"cta":"src-slices-EmailFormSlice-body-CTA__cta"};